import { render, staticRenderFns } from "./TrexCodeAdmin.vue?vue&type=template&id=71e0e4f0"
import script from "./TrexCodeAdmin.vue?vue&type=script&lang=js"
export * from "./TrexCodeAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports